// extracted by css-extract-rspack-plugin
export default {"linkNavigationGroup":"header-fragment__LinkNavigationGroup_linkNavigationGroup__-1zXd"};